// src/theme/atomic/green.ts
var green = {
  10: "#00240C",
  20: "#004517",
  30: "#006E25",
  40: "#009632",
  50: "#00BF40",
  60: "#1ED45A",
  70: "#49E57D",
  80: "#7DF5A5",
  90: "#ACFCC7",
  95: "#D9FFE6",
  99: "#F2FFF6"
};
var green_default = green;

export { green_default as default };
